import { z } from 'zod'
import { linkDto } from './../content.shared.dtos'

export const sideBarSection = z.object({
  name: z.string().nullable(),
  links: z.array(linkDto),
})
export type SideBarSection = z.infer<typeof sideBarSection>
